import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

import { useLDFlag } from '@/data/LD/selectors/getLDFlag';
import { MenuItem } from '@/shared/components/nav/MenuItem';
import FontIcon from '@/shared/ui/FontIcon';
import { posthogCapture } from '@/shared/vendor/posthog';
import { useWiwDispatch } from '@/store';
import { openSendMessageDialog } from '@/teamtxt/dialogs';
import WorkChatV2 from '@/workchat/v2/components/WorkChatV2';
import WorkChatV3 from '@/workchat/v3/components/WorkChatV3';

type WorkchatMenuItemProps = {
  workchat?: boolean;
  setup?: boolean;
  broadcast?: boolean;
  isDesktop?: boolean;
};

const WorkchatMenuItem = ({ workchat, setup, broadcast, isDesktop }: WorkchatMenuItemProps) => {
  const [showDropdown, updateShowDropdown] = useState(false);
  const dispatch = useWiwDispatch();

  const fdt1167 = useLDFlag('fdt-1167-work-chat-stream-migration');
  const WorkChatComponent = fdt1167 ? WorkChatV3 : WorkChatV2;

  function onInteraction() {
    posthogCapture('top_nav.workchat');
  }

  function handleOpenSendMessage() {
    onInteraction();
    dispatch(openSendMessageDialog());
  }

  return (
    <Fragment>
      {workchat && isDesktop && (
        <li
          id="workchat-container"
          className={`nav-item workchat hide-label-tablet dropdown-starts-left ${
            !isDesktop && showDropdown ? 'show' : ''
          } dropdown`}
          onClick={() => updateShowDropdown(!showDropdown)}
          data-testid="workchat-menu"
        >
          <WorkChatComponent />
        </li>
      )}

      {workchat && !isDesktop && (
        // biome-ignore lint/a11y/noStaticElementInteractions: required
        <div
          id="workchat-container"
          className={`workchat hide-label-tablet dropdown-starts-left ${
            !isDesktop && showDropdown ? 'show' : ''
          } dropdown`}
          onClick={() => updateShowDropdown(!showDropdown)}
          data-testid="workchat-menu"
        >
          <WorkChatComponent />
        </div>
      )}

      {setup && isDesktop && (
        <MenuItem
          data-testid="top-nav-workchat"
          onClick={onInteraction}
          icon="workchat"
          label="WorkChat"
          hideLabel="tablet"
          show={true}
          to="/workchat/setup"
        />
      )}

      {setup && !isDesktop && (
        <Link className="workchat-nav-item" to="/workchat/setup">
          <FontIcon icon="workchat" />
          <span>WorkChat</span>
        </Link>
      )}

      {broadcast && isDesktop && (
        <MenuItem
          data-testid="top-nav-workchat"
          icon="workchat"
          label="Message Staff"
          hideLabel="tablet"
          onClick={handleOpenSendMessage}
          show={true}
        />
      )}

      {broadcast && !isDesktop && (
        <button
          data-testid="top-nav-workchat"
          type="button"
          className="workchat-nav-item"
          onClick={handleOpenSendMessage}
        >
          <FontIcon icon="workchat" />
          <span>Message Staff</span>
        </button>
      )}
    </Fragment>
  );
};

export default WorkchatMenuItem;
